import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { BRANDS, useBranding } from "@/lib/branding";

// /chevron, /daikin, /flexspace — set the brand in the provider (and thus
// localStorage), then redirect to the PersonaPicker. All subsequent pages
// pick up the brand from context so the whole session stays branded.
export default function BrandLandingRedirect() {
  const { pathname } = useLocation();
  const brandId = pathname.replace("/", "").trim();
  const { setBrand } = useBranding();

  useEffect(() => {
    if (brandId && BRANDS[brandId]) {
      setBrand(brandId);
    }
  }, [brandId, setBrand]);

  return <Navigate to="/" replace />;
}
